import React from 'react';
import './index.css';

function Disclaimer () {
    return (
        <div>
            <div>
                <headerSynth className='center'>Synth</headerSynth>
            </div>
            <subheader>Disclaimer:</subheader>
            <div className='glass'>
            We do not claim ownership of any songs, albums, or artists featured on this site.
            All songs are provided for demonstration purposes only and are truncated for compliance with copyright laws.
            This site is not operated for profit; it is solely for educational and proof of concept purposes.
            </div>
        </div>
    );
}
 
export default Disclaimer;